export default "__VITE_PUBLIC_ASSET__3a4f3b30__"